import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const PrivateLimitedCompany = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Private Limited Company
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Private Limited Company Registration is an excellent option for startups
        seeking funding and sustainable growth. This business entity limits
        owner liability to their share capital and restricts the number of
        shareholders to 200.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* About Private Limited Company */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              About Private Limited Company
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A Private Limited Company is the most favored business structure in
            India, with over 20 lakh companies registered as of October 2020, of
            which 12 lakh remain active. Governed by the Ministry of Corporate
            Affairs (MCA) under the Companies Act, 2013, it is highly regarded
            by customers, suppliers, bankers, and the government. This structure
            allows entrepreneurs to establish a scalable business, raise capital
            effortlessly, and transfer ownership with ease through shares.
          </p>

          {/* Key Features */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Key Features
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>Limits shareholder liability to their share capital investment.</li>
            <li>Restricts the number of shareholders to a maximum of 200.</li>
            <li>Recognized as a separate legal entity with its own PAN.</li>
            <li>Allows easy replacement of directors and transfer of shares.</li>
            <li>Enables raising equity and debt financing from various sources.</li>
          </ul>

          {/* Advantages */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Advantages of Registration
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <ul
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              <strong>Limited Liability:</strong> Shareholders are protected
              from personal liability in case of losses or legal issues.
            </li>
            <li>
              <strong>Capital Raising:</strong> Attracts funding from angel
              investors, venture capital, private equity, and banks.
            </li>
            <li>
              <strong>Separate Entity:</strong> Operates independently, allowing
              asset ownership and debt management.
            </li>
            <li>
              <strong>Growth Potential:</strong> Supports scalability and
              expansion with ease.
            </li>
            <li>
              <strong>Credibility:</strong> Enhances trust among stakeholders
              due to legal recognition.
            </li>
          </ul>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Registration Process
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            The registration process involves the following steps:
          </p>
          <ol
            style={{
              paddingLeft: isMobile ? "15px" : "20px",
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            <li>
              Submit identity proof (PAN or passport), address proof, and
              residence proof (e.g., bank statement) for at least two directors.
            </li>
            <li>
              Apply for name approval from the MCA, submitting up to two name
              options (re-submission allowed if rejected).
            </li>
            <li>
              Obtain Digital Signature Certificates (DSC) for directors to sign
              the incorporation application.
            </li>
            <li>
              File the SPICe+ form with the MCA for incorporation, bypassing
              separate RUN name approval.
            </li>
            <li>
              Receive the incorporation certificate, PAN, and TAN within 2-3
              business days, followed by opening a current account.
            </li>
          </ol>

          {/* Required Documents */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Documents
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For directors and shareholders: Scanned copies of PAN card (or
            passport for foreigners), voter ID/passport/driver’s license, recent
            utility bill (less than 2 months old), and a passport-sized photo
            with specimen signature.
          </p>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            For registered office: Recent utility bill (e.g., electricity),
            rental agreement, NOC from the landlord, or sale deed (if owned
            property). The office can be a residence or commercial space.
          </p>

          {/* Reasons to Register */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Reasons to Register
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Registering a company offers distinct legal status and perpetual
            succession, unaffected by changes in membership. It provides limited
            liability, asset ownership, share transferability, and the ability
            to raise equity, making it ideal for long-term growth and investor
            appeal.
          </p>

          {/* Conclusion */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Conclusion
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            A Private Limited Company is a robust choice for entrepreneurs aiming
            for funding and scalability. Its legal protections, growth
            potential, and credibility make it a cornerstone for building a
            successful business in India.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivateLimitedCompany;